import { useEffect, useState } from "react";
import api from "@/lib/api";
import AIContentBlock from "@/components/AIContentBlock";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export default function News() {
  const [news, setNews] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/news").then((r) => setNews(r.data)).catch(console.error);
  }, []);

  const fmt = (d) => new Date(d).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="news-page">
      <p className="text-xs font-bold uppercase tracking-[0.3em] text-slate-500 mb-3">News, Interviews &amp; Reviews</p>
      <h1 className="font-display text-4xl sm:text-5xl font-black text-slate-900">Stories From the <span className="gradient-text">Global Scene.</span></h1>
      <p className="mt-3 text-slate-600 max-w-2xl">Independent editorial coverage — reporting, criticism and community journalism, clearly separated from promotion.</p>

      <AIContentBlock pageKey="news" topic="Global music news and cultural journalism" imgQuery="music concert photography press" />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
        {news.map((n) => (
          <button key={n.slug} onClick={() => setActive(n)} data-testid={`news-card-${n.slug}`} className="card-lift text-left bg-white rounded-3xl border border-slate-100 overflow-hidden group">
            <div className="h-44 overflow-hidden">
              <img src={n.image} alt={n.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-5">
              <p className="text-[10px] font-black uppercase tracking-widest text-purple-600">{n.desk} · {fmt(n.date)}</p>
              <h2 className="font-display text-lg font-black text-slate-900 mt-2 leading-snug group-hover:text-pink-600 transition-colors">{n.title}</h2>
              <p className="text-sm text-slate-600 mt-2 line-clamp-2">{n.excerpt}</p>
            </div>
          </button>
        ))}
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-2xl" data-testid="news-dialog">
          {active && (
            <>
              <DialogHeader>
                <p className="text-[10px] font-black uppercase tracking-widest text-purple-600">{active.desk} · {fmt(active.date)}</p>
                <DialogTitle className="font-display text-2xl font-black text-left">{active.title}</DialogTitle>
                <DialogDescription className="text-left">{active.excerpt}</DialogDescription>
              </DialogHeader>
              <img src={active.image} alt={active.title} className="rounded-2xl w-full h-56 object-cover" />
              <p className="text-sm text-slate-600 leading-relaxed">{active.body}</p>
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
